// cart-drawer.js
class CartDrawer extends HTMLElement {

    constructor() {
        super();

        this.addEventListener(
            "keyup",
            (evt) => evt.code === "Escape" && this.close()
        );
        this.querySelector("#CartDrawer-Overlay").addEventListener(
            "click",
            this.close.bind(this)
        );
        this.setHeaderCartIconAccessibility();
        this.setupCartTotalPriceListeners();
    }

    // Add this new method
    calculateFinalAmount(cartData) {
        // If cart is empty, return 0
        if (
            !cartData ||
            cartData.item_count === 0 ||
            cartData.original_total_price === 0
        ) {
            return 0;
        }

        const tier1_paise = (window.shopSettings?.price1 || 0) * 100;
        const tier2_paise = (window.shopSettings?.price2 || 0) * 100;
        const tier3_paise = (window.shopSettings?.price3 || 0) * 100;
        const shipping_cost = window.shopSettings?.cart_shipping || 0;



        let final_amount = cartData.original_total_price;


        console.log('tier1_paise: ' + tier1_paise);
        console.log('tier2_paise: ' + tier2_paise);
        console.log('tier3_paise: ' + tier3_paise);
        console.log('shipping_cost: ' + shipping_cost);
        console.log('final_amount after checking delivery charges: ' + final_amount);

        // Calculate shipping
        const free_shipping =
            tier1_paise > 0 && cartData.total_price >= tier1_paise;

        console.log('free_shipping: ' + free_shipping);
        if (!free_shipping && shipping_cost > 0) {
            final_amount += shipping_cost * 100;
        }

        console.log('final_amount after checking delivery charges: ' + final_amount);
        // Calculate discount
        let discount_percentage = 0;
        if (tier3_paise > 0 && cartData.original_total_price >= tier3_paise) {
            console.log('if tier3_paise: ' + tier3_paise);
            console.log('if cartData original_total_price: ' + cartData.original_total_price);
            discount_percentage = window.shopSettings?.discount3 || 0;
        } else if (tier2_paise > 0 && cartData.original_total_price >= tier2_paise) {
            console.log('else tier2_paise: ' + tier2_paise);
            console.log('else cartData original_total_price: ' + cartData.original_total_price);
            discount_percentage = window.shopSettings?.discount2 || 0;
        }

        console.log('discount_percentage: ' + discount_percentage);

        if (discount_percentage > 0) {
            const discount_amount =
                (cartData.original_total_price * discount_percentage) / 100;
            final_amount -= discount_amount;
        }

        console.log('final_amount return: ' + final_amount);
        return final_amount;
    }

    setHeaderCartIconAccessibility() {
        const cartLink = document.querySelector("#cart-icon-bubble");
        cartLink.setAttribute("role", "button");
        cartLink.setAttribute("aria-haspopup", "dialog");
        if (!document.body.classList.contains("template-cart")) {
            cartLink.addEventListener("click", (event) => {
                event.preventDefault();
                this.open(cartLink);
            });
            cartLink.addEventListener("keydown", (event) => {
                if (event.code.toUpperCase() === "SPACE") {
                    event.preventDefault();
                    this.open(cartLink);
                }
            });
        }
    }

    setupCartTotalPriceListeners() {
        const cartChangeEvents = ["cart:updated", "cart:changed", "cart:refresh"];

        cartChangeEvents.forEach((eventName) => {
            document.addEventListener(eventName, () => {
                setTimeout(() => this.updateCartTotalPrice(), 100);
            });

            $(document).on(eventName, () => {
                setTimeout(() => this.updateCartTotalPrice(), 100);
            });
        });

        if (typeof PUB_SUB_EVENTS !== "undefined" && PUB_SUB_EVENTS.cartUpdate) {
            document.addEventListener(PUB_SUB_EVENTS.cartUpdate, () => {
                setTimeout(() => this.updateCartTotalPrice(), 100);
            });
        }

        $(document).on(
            "click change submit input blur",
            `
  #CartDrawer .cart-remove-button,
  #CartDrawer .cart-item-remove,
  #CartDrawer [href*="cart/change"],
  #CartDrawer [data-href*="cart/change"],
  #CartDrawer .remove-cart-item,
  #CartDrawer [onclick*="cart/change"],
  #CartDrawer .cart__remove,
   #CartDrawer .btn--remove,
    #CartDrawer a[href*="/cart/change"],
    #CartDrawer button[data-line],
     #CartDrawer input[name*="updates"],
     #CartDrawer .cart-item input[type="number"],
    #CartDrawer .quantity__input,
    #CartDrawer form[action*="/cart"]
    `,
            () => setTimeout(() => this.updateCartTotalPrice(), 150)
        );

        // Initialize on page load
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', () => {
                setTimeout(() => this.updateCartTotalPrice(), 200);
            });
        } else {
            setTimeout(() => this.updateCartTotalPrice(), 100);
        }
    }


    open(triggeredBy) {
        if (triggeredBy) this.setActiveElement(triggeredBy);
        const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
        if (cartDrawerNote && !cartDrawerNote.hasAttribute("role"))
            this.setSummaryAccessibility(cartDrawerNote);
        // here the animation doesn't seem to always get triggered. A timeout seem to help
        setTimeout(() => {
            this.classList.add("animate", "active");
        });

        this.addEventListener(
            "transitionend",
            () => {
                const containerToTrapFocusOn = this.classList.contains("is-empty") ?
                    this.querySelector(".drawer__inner-empty") :
                    document.getElementById("CartDrawer");
                const focusElement =
                    this.querySelector(".drawer__inner") ||
                    this.querySelector(".drawer__close");
                trapFocus(containerToTrapFocusOn, focusElement);

                // Initialize slider after drawer opens
                setTimeout(() => initializeComplementarySlider(), 300);
            }, {
                once: true
            }
        );

        document.body.classList.add("overflow-hidden");
    }

    close() {
        this.classList.remove("active");
        removeTrapFocus(this.activeElement);
        document.body.classList.remove("overflow-hidden");
    }

    setSummaryAccessibility(cartDrawerNote) {
        cartDrawerNote.setAttribute("role", "button");
        cartDrawerNote.setAttribute("aria-expanded", "false");

        if (cartDrawerNote.nextElementSibling.getAttribute("id")) {
            cartDrawerNote.setAttribute(
                "aria-controls",
                cartDrawerNote.nextElementSibling.id
            );
        }

        cartDrawerNote.addEventListener("click", (event) => {
            event.currentTarget.setAttribute(
                "aria-expanded",
                !event.currentTarget.closest("details").hasAttribute("open")
            );
        });

        cartDrawerNote.parentElement.addEventListener("keyup", onKeyUpEscape);
    }

    renderContents(parsedState) {
        this.querySelector(".drawer__inner").classList.contains("is-empty") &&
            this.querySelector(".drawer__inner").classList.remove("is-empty");
        this.productId = parsedState.id;
        this.getSectionsToRender().forEach((section) => {
            const sectionElement = section.selector ?
                document.querySelector(section.selector) :
                document.getElementById(section.id);
            sectionElement.innerHTML = this.getSectionInnerHTML(
                parsedState.sections[section.id],
                section.selector
            );
        });

        // Update cart total price
        setTimeout(() => this.updateCartTotalPrice(), 100);

        setTimeout(() => {
            this.querySelector("#CartDrawer-Overlay").addEventListener(
                "click",
                this.close.bind(this)
            );
            this.open();
        });
    }

    updateCartTotalPrice() {
        // Ensure shopSettings are available
        if (!window.shopSettings) {
            setTimeout(() => this.updateCartTotalPrice(), 250);
            return;
        }

        fetch("/cart.js")
            .then((response) => response.json())
            .then((cartData) => {
                console.log(cartData);
                // Calculate final amount with shipping and discounts
                const finalAmount = this.calculateFinalAmount(cartData);

                const formattedPrice = new Intl.NumberFormat("en-US", {
                    style: "currency",
                    currency: cartData.currency,
                }).format(cartData.total_price / 100);

                const priceElement = document.querySelector(
                    ".shopping-cart-total-price"
                );

                console.log('formattedPrice: ' + formattedPrice);
                if (priceElement) {
                    priceElement.textContent = formattedPrice;
                    // Force DOM reflow
                    priceElement.offsetHeight;
                }
            })
            .catch((error) => {
                console.error("Cart total price update failed:", error);
                setTimeout(() => this.updateCartTotalPrice(), 500);
            });
    }

    getSectionInnerHTML(html, selector = ".shopify-section") {
        return new DOMParser()
            .parseFromString(html, "text/html")
            .querySelector(selector).innerHTML;
    }

    getSectionsToRender() {
        return [{
                id: "cart-drawer",
                selector: "#CartDrawer",
            },
            {
                id: "cart-icon-bubble",
            },
        ];
    }

    getSectionDOM(html, selector = ".shopify-section") {
        return new DOMParser()
            .parseFromString(html, "text/html")
            .querySelector(selector);
    }

    setActiveElement(element) {
        this.activeElement = element;
    }
}

customElements.define("cart-drawer", CartDrawer);

class CartDrawerItems extends CartItems {
    getSectionsToRender() {
        return [{
                id: 'CartDrawer',
                section: 'cart-drawer',
                selector: '.drawer__inner',
            },
            {
                id: 'cart-icon-bubble',
                section: 'cart-icon-bubble',
                selector: '.shopify-section',
            },
        ];
    }
}

customElements.define("cart-drawer-items", CartDrawerItems);